import { createApp } from 'vue'
import 'normalize.css';
import App from './App.vue'
import router from './router'
import '@/utils/remAdaptor'
import staticConfig from '@/constant'


// 修改网站title
document.title = staticConfig.title

// 修改 favicon（运行时根据配置替换）
const setFavicon = (href) => {
  if (!href) return
  const linkId = 'dynamic-favicon'
  let link = document.getElementById(linkId)
  if (!link) {
    link = document.createElement('link')
    link.id = linkId
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.href = href
}

setFavicon(staticConfig.favicon)

createApp(App).use(router).mount('#app')
